import { render, staticRenderFns } from "./selectcaselist.vue?vue&type=template&id=db657280&scoped=true&"
import script from "./selectcaselist.vue?vue&type=script&lang=js&"
export * from "./selectcaselist.vue?vue&type=script&lang=js&"
import style0 from "./selectcaselist.vue?vue&type=style&index=0&id=db657280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db657280",
  null
  
)

export default component.exports